export default "__VITE_ASSET__DhDaM43U__"